import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router";
import { useData } from "../../../components/firebase/DataProvider";
import { FieldValue } from "../../../components/firebase/FirebaseProvider";
import { withStyles } from "@material-ui/core/styles";
import Gap from "../../../components/atoms/Gap";
import Header from "../../../components/molecules/Header";
import useStyles from "./style";
import Alamat from "./alamat";
import Item from "./item";
import {
  Typography,
  TextField,
  Switch,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
} from "@material-ui/core";
import MuiAccordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import AccessAlarmsIcon from "@material-ui/icons/AccessAlarms";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import currency from "../../../utils/currency";
import { findOnePromoOngkir } from "../../../utils/promo";

function WaitingForPayment() {
  const { orders } = useData();

  const history = useHistory();

  const pendingOrders =
    orders &&
    orders.filter((order) => {
      return order.status === "not-paid" || order.status === "pending";
    });

  if (pendingOrders && pendingOrders.length <= 0) {
    return (
      <>
        <Gap height={16} />
        <Button
          variant="outlined"
          color="primary"
          onClick={() => history.push("/")}
          style={{ textTransform: "capitalize" }}
        >
          Belanja Sekarang
        </Button>
      </>
    );
  }

  return (
    <>
      <Typography>
        Ada {pendingOrders && pendingOrders.length} pesanan menunggu pembayaran!
      </Typography>
      <Gap height={16} />
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          history.push("/transaksi/transaksilist/sellerapp/tokorame");
        }}
        style={{ textTransform: "capitalize" }}
      >
        Cek di Transaksi
      </Button>
    </>
  );
}

function Cart() {
  const classes = useStyles();
  const history = useHistory();
  const { cart, cartRef, orders, promoOngkir, preorderUtils } = useData();
  const [invalidJumlah, setInvalidJumlah] = useState({});
  const [dialogResi, setDialogResi] = useState(false);
  const [load, setLoad] = useState(false);

  const pendingOrders =
    orders?.filter?.((order) => {
      return (
        (order.order_info?.location === "sellerapp" &&
          order.status === "not-paid") ||
        order.status === "pending"
      );
    }) ?? [];

  const subcarts = Object.entries(cart?.subcarts ?? {}).sort((a, b) => {
    return a[1].created_at?.toMillis?.() - b[1].created_at?.toMillis?.();
  });

  const pilihSemua = subcarts.filter(([key, val]) => val.checked === "Y");

  const boolInvalidJumlah = Object.values(invalidJumlah).some(
    (item) =>
      Object.values(item?.total ?? {}).reduce((n1, n2) => n1 + n2, 0) >
      item?.stok
  );

  const boolInvalidKadalwarsa = Object.values(invalidJumlah).some(
    (item) => item.orderable === false
  );

  const boolInvalidDifferentType = Object.values(invalidJumlah).some(
    (item) => item?.duplicateType
  );

  const callSetInvalidJumlah = useCallback(
    (id, stok, alamatId, jumlah, productType, orderable, duplicateType) => {
      setInvalidJumlah((old) => {
        if (!old.hasOwnProperty(id)) {
          old[id] = {
            stok,
            total: { [alamatId]: jumlah },
            duplicateType,
            productType,
            orderable,
          };
        } else {
          old[id].total[alamatId] = jumlah;
          old[id].stok = stok;
          old[id].duplicateType = duplicateType;
          old[id].productType = productType;
          old[id].orderable = orderable;
        }

        return { ...old };
      });
    },
    []
  );

  let arr = [];
  subcarts.map(([key, val]) =>
    Object.entries(val?.products).map(([_, dataProducts]) => {
      return arr.push(dataProducts?.type);
    })
  );

  let typeProduk = [...new Set(arr)];

  const handleChexbox = () => {
    setLoad(true);
    if (pilihSemua.length <= 0) {
      if (typeProduk?.length === 1) {
        subcarts.map(async ([alamatId, val]) => {
          if (Object.values(val?.products)?.[0]?.type === typeProduk?.[0]) {
            await cartRef.set(
              {
                subcarts: {
                  [alamatId]: {
                    checked: "Y",
                  },
                },
                updated_at: FieldValue.serverTimestamp(),
              },
              { merge: true }
            );
          }
        });
      } else {
        subcarts.map(async ([alamatId, val]) => {
          if (Object.values(val?.products)?.[0]?.type === "normal") {
            await cartRef.set(
              {
                subcarts: {
                  [alamatId]: {
                    checked: "Y",
                  },
                },
                updated_at: FieldValue.serverTimestamp(),
              },
              { merge: true }
            );
          }
        });
      }
    } else {
      subcarts.map(async ([alamatId, val]) => {
        if (
          Object.values(val?.products)?.[0]?.type ===
          Object?.values(pilihSemua?.[0]?.[1]?.products ?? {})?.[0]?.type
        ) {
          await cartRef.set(
            {
              subcarts: {
                [alamatId]: {
                  checked: "Y",
                },
              },
              updated_at: FieldValue.serverTimestamp(),
            },
            { merge: true }
          );
        }
      });
    }
    setLoad(false);
  };

  const handleBatalkan = () => {
    setLoad(true);
    subcarts.map(async ([alamatId]) => {
      await cartRef.set(
        {
          subcarts: {
            [alamatId]: {
              checked: "N",
              asuransi_pengiriman: 0,
              biaya_pengiriman: 0,
              biaya_pengiriman_before: 0,
              pengiriman: FieldValue.delete(),
              resi_otomatis_mp: FieldValue.delete(),
              resi_otomatis_mp_kurir: FieldValue.delete(),
              resi_otomatis_mp_resi: FieldValue.delete(),
              resi_otomatis_mp_file: FieldValue.delete(),
            },
          },
          updated_at: FieldValue.serverTimestamp(),
        },
        { merge: true }
      );
    });
    setLoad(false);
  };

  const total = subcarts.reduce?.(
    (total, [key, value]) => {
      let data = 0;
      let data_dp = 0;
      let total_alamat = total.total_alamat;
      let totalTagihan = total.totalTagihan;
      let totalDownPayment = total.totalDownPayment;

      if (value.checked === "Y") {
        data = value.total_tagihan;
        data_dp = value.nilai_dp;
        total_alamat = total.total_alamat + 1;
        totalTagihan = total.totalTagihan + data;
        totalDownPayment = total.totalDownPayment + data_dp;
      }

      return {
        total_alamat,
        totalTagihan,
        totalDownPayment,
      };
    },
    {
      total_alamat: 0,
      totalTagihan: 0,
      totalDownPayment: 0,
    }
  );

  return (
    <>
      <Header
        title="Keranjang"
        type="with-title"
        onClick={() => history.goBack()}
      />
      <Gap height={60} />
      {!cart || Object.keys(cart.subcarts ?? {}) <= 0 ? (
        <div className={classes.emptyCart}>
          <Typography className={classes.emptyCartTitle}>
            Wah, keranjang belanjamu masih kosong
          </Typography>
          <WaitingForPayment />
        </div>
      ) : (
        <>
          <Paper elevation={0} className={classes.pilihSemuaSection}>
            <div className={classes.wrapPilihSemua}>
              <IconButton
                size="medium"
                onClick={
                  pilihSemua?.length !== subcarts.length
                    ? handleChexbox
                    : handleBatalkan
                }
              >
                {pilihSemua?.length <= 0 ? (
                  <CheckBoxOutlineBlankIcon />
                ) : (
                  <CheckBoxIcon color="primary" />
                )}
              </IconButton>
              <Typography className={classes.liquidPrimary}>
                {pilihSemua?.length} Orderan
              </Typography>
            </div>
            <div className={classes.tambahProduk}>
              <Button
                // size="small"
                style={{ fontSize: "13px", textTransform: "capitalize" }}
                color="primary"
                onClick={() => history.push("/")}
              >
                Tambah produk
              </Button>
            </div>
          </Paper>
          <div style={{ paddingBottom: 72.5 }}>
            {/* <Gap height={50} /> */}
            <Divider />
            {pendingOrders.length > 0 ? (
              <>
                <Paper
                  elevation={0}
                  className={classes.wrapNotif}
                  onClick={() =>
                    history.push("transaksi/transaksilist/sellerapp/tokorame")
                  }
                >
                  <AccessAlarmsIcon style={{ color: "#5AA5EA" }} />
                  <Gap width={6} />
                  <Typography className={classes.liquidNotif}>
                    {pendingOrders.length} Pesananmu belum dibayar nih, yuk
                    bayar sekarang
                  </Typography>
                </Paper>
                <Divider style={{ backgroundColor: "#5AA5EA" }} />
              </>
            ) : null}
            <Paper elevation={0}>
              {subcarts.map?.(([alamatId, subcart]) => {
                const products = Object.entries(subcart?.products ?? {});
                const check = subcart?.checked;
                if (!check && products?.length > 0) {
                  cartRef.set(
                    {
                      subcarts: {
                        [alamatId]: {
                          checked: "N",
                          asuransi_pengiriman: 0,
                          biaya_pengiriman: 0,
                          biaya_pengiriman_before: 0,
                          pengiriman: FieldValue.delete(),
                          resi_otomatis_mp: FieldValue.delete(),
                          resi_otomatis_mp_kurir: FieldValue.delete(),
                          resi_otomatis_mp_resi: FieldValue.delete(),
                          resi_otomatis_mp_file: FieldValue.delete(),
                        },
                      },
                      updated_at: FieldValue.serverTimestamp(),
                    },
                    { merge: true }
                  );
                }
                return (
                  <ItemCart
                    alamatId={alamatId}
                    subcart={subcart}
                    products={products}
                    callSetInvalidJumlah={callSetInvalidJumlah}
                    invalidJumlah={invalidJumlah}
                    cartRef={cartRef}
                    load={load}
                    setLoad={setLoad}
                    dialogResi={dialogResi}
                    setDialodResi={setDialogResi}
                    check={check}
                    promoOngkir={promoOngkir}
                    preorderUtils={preorderUtils}
                  />
                );
              })}
            </Paper>
          </div>
          <div
            style={{
              position: "fixed",
              backgroundColor: "white",
              bottom: 0,
              maxWidth: "100%",
              width: "960px",
              left: "auto",
              right: "auto",
            }}
          >
            <div
              style={{
                paddingRight: "20px",
                paddingLeft: "20px",
                paddingTop: "7.5px",
                paddingBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Typography
                  style={{
                    fontSize: 12.3,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {preorderUtils?.down_payment_option &&
                  total?.totalDownPayment > 0
                    ? "Total Down Payment"
                    : "Total Tagihan"}
                </Typography>{" "}
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                  color="secondary"
                >
                  {currency(
                    preorderUtils?.down_payment_option &&
                      total?.totalDownPayment > 0
                      ? total?.totalDownPayment
                      : total?.totalTagihan
                  )}
                </Typography>{" "}
                <Typography
                  style={{
                    fontSize: 12,
                  }}
                >
                  {total?.total_alamat} orderan
                </Typography>
              </div>
              <div style={{ alignSelf: "flex-end" }}>
                {total?.total_alamat > 0 ? (
                  <Button
                    // style={{ textTransform: "capitalize" }}
                    onClick={() => history.push("/checkout")}
                    // fullWidth
                    disabled={
                      total?.totalTagihan <= 0 ||
                      total?.total_alamat < 0 ||
                      boolInvalidJumlah ||
                      boolInvalidKadalwarsa ||
                      boolInvalidDifferentType ||
                      load
                    }
                    color="primary"
                    size="small"
                    variant="contained"
                  >
                    Pilih Pengiriman
                  </Button>
                ) : (
                  <Button
                    // style={{ textTransform: "capitalize" }}
                    onClick={handleChexbox}
                    // fullWidth
                    color="primary"
                    size="small"
                    variant="outlined"
                  >
                    Pilih Orderan
                  </Button>
                )}
              </div>
            </div>
          </div>
          <Dialog open={dialogResi} onClose={() => setDialogResi(false)}>
            <DialogTitle>
              {" "}
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                Resi Otomatis Marketplace
              </Typography>
            </DialogTitle>
            <DialogContent dividers>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {" "}
                  <Typography
                    style={{
                      fontSize: 14,
                    }}
                  >
                    Resi otomatis marketplace adalah penjualan melalui
                    marketplace lain (Shopee, Tokopedia, Bukalapak, Blibli,
                    Lazada, dsb) dan sudah memiliki resi pengiriman.{" "}
                  </Typography>
                </div>
                <div style={{ alignSelf: "center" }}>
                  <LocalMallOutlinedIcon fontSize="large" color="primary" />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                fullWidth
                size="small"
                color="primary"
                onClick={() => setDialogResi(false)}
              >
                Tutup
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
}

const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const ItemCart = ({
  alamatId,
  subcart,
  products,
  callSetInvalidJumlah,
  invalidJumlah,
  cartRef,
  load,
  setLoad,
  dialogResi,
  setDialodResi,
  check,
  promoOngkir,
  preorderUtils,
}) => {
  const classes = useStyles();

  const [note, setNote] = useState("");

  const [dialogResiOtomatis, setDialogResiOtomatis] = useState(false);

  const [checkedResi, setCheckedResi] = useState(false);

  useEffect(() => {
    setCheckedResi(subcart?.resi_otomatis_mp);
  }, [subcart?.resi_otomatis_mp]);

  const handleOpenDialogResi = async (e) => {
    if (!checkedResi) {
      setDialogResiOtomatis(true);
    } else {
      onToggleSwitch();
    }
  };

  const onToggleSwitch = async () => {
    setLoad(true);
    const data = {
      subcarts: {
        [alamatId]: {
          pengiriman: FieldValue.delete(),
          resi_otomatis_mp: !checkedResi,
          promo_ongkir: FieldValue.delete(),
          resi_otomatis_mp_resi: !checkedResi ? "" : FieldValue.delete(),
          resi_otomatis_mp_kurir: !checkedResi ? "" : FieldValue.delete(),
          resi_otomatis_mp_file: !checkedResi ? "" : FieldValue.delete(),
          biaya_pengiriman: 0,
          total_pembayaran: subcart?.total_tagihan,
          asuransi_pengiriman: 0,
          biaya_pengiriman_before: FieldValue.delete(),
        },
      },
      updated_at: FieldValue.serverTimestamp(),
    };
    await cartRef.set(data, { merge: true });
    setDialogResiOtomatis(false);
    setCheckedResi(!checkedResi);
    setLoad(false);
  };

  const handleNoted = () => {
    setLoad(true);
    const data = {
      subcarts: {
        [alamatId]: {
          note: note,
        },
      },

      updated_at: FieldValue.serverTimestamp(),
    };
    cartRef.set(data, { merge: true });
    setLoad(false);
  };

  const refTotal = useRef({});

  const totalHarga = useMemo(() => {
    const prices = Object.values(refTotal.current);
    if (prices.length >= products.length) {
      return prices.reduce((prev, curr) => prev + Math.round(curr), 0);
    }

    return 0;
  }, [refTotal.current]);

  const setProducts = useCallback(async (id, jumlah, harga) => {
    refTotal.current = { ...refTotal.current, [id]: jumlah * harga };
  }, []);

  let isPreorder =
    subcart?.nilai_dp && preorderUtils?.down_payment_option
      ? {
          nilai_dp: Math.round(
            (preorderUtils?.down_payment_percentage / 100) * totalHarga
          ),
        }
      : "";

  useEffect(() => {
    setLoad(true);

    if (totalHarga > 0 && products?.length > 0) {
      cartRef
        .set(
          {
            subcarts: {
              [alamatId]: {
                total_tagihan: totalHarga,
                total_pembayaran: totalHarga,
                asuransi_pengiriman: 0,
                biaya_pengiriman: 0,
                defaultPengiriman: false,
                tipe_order: FieldValue.delete(),
                pengiriman: FieldValue.delete(),
                biaya_pengiriman_before: FieldValue.delete(),
                pakai_asuransi: FieldValue.delete(),
                nilai_promo_ongkir: FieldValue.delete(),
                nilai_promo_produk: FieldValue.delete(),
                inpoin: FieldValue.delete(),
                nilai_infaq: FieldValue.delete(),
                promo_ongkir: FieldValue.delete(),
                nilai_promo: FieldValue.delete(),
                promo_voucher: FieldValue.delete(),
                nilai_voucher: FieldValue.delete(),
                kategori_voucher: FieldValue.delete(),
                total_tagihan_before_vouher: FieldValue.delete(),
                ...isPreorder,
              },
            },
            type: "webseller",
            unique_code: FieldValue.delete(),
            is_payment_code: FieldValue.delete(),
            is_payment_name: FieldValue.delete(),
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        )
        .catch((err) => console.log("error effect total_tagihan", err));
    }
    if (products?.length === 0) {
      cartRef
        .set(
          {
            subcarts: {
              [alamatId]: FieldValue.delete(),
            },

            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        )
        .catch((err) => console.log("error effect total_tagihan", err));
    }
    setLoad(false);
  }, [totalHarga]);

  const findPromoOngkirAgain = findOnePromoOngkir(promoOngkir);
  const textBadgePromoOngkir = (() => {
    let text = "";
    if (findPromoOngkirAgain) {
      if (findPromoOngkirAgain?.tipe === "%") {
        text = `${findPromoOngkirAgain?.nilai}%`;
      } else {
        text = `${findPromoOngkirAgain?.max_promo_ongkir / 1000}rb`;
      }
    }
    return text;
  })();

  return (
    <>
      <Alamat id={alamatId} subcart={subcart} />
      {/* <Divider /> */}
      <Accordion defaultExpanded={true}>
        <AccordionSummary
          style={{ minHeight: "0px" }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "-20px",
              marginBottom: "-20px",
            }}
          >
            <LocalMallOutlinedIcon />
            <Gap width={16} />
            <Typography className={classes.liquidPrimary}>
              Jumlah Produk: {products?.length}
            </Typography>
          </div>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <div style={{ width: "100%" }}>
            {products
              ?.sort((a, b) => {
                return (
                  a[1].created_at?.toMillis?.() - b[1].created_at?.toMillis?.()
                );
              })
              .map(([variantId, variant], index) => {
                return (
                  <Item
                    key={variantId}
                    products={products}
                    alamatId={alamatId}
                    variantId={variantId}
                    variant={variant}
                    index={index}
                    // load={load}
                    // setLoad={setLoad}
                    invalidJumlah={invalidJumlah}
                    callSetInvalidJumlah={callSetInvalidJumlah}
                    setProducts={setProducts}
                    check={check}
                  />
                );
              })}
          </div>
        </AccordionDetails>
      </Accordion>
      <Divider />
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        <Typography className={classes.liquidSmall}>Pesan</Typography>
        <TextField
          style={{ marginTop: "5px" }}
          id="note"
          name="note"
          // label="Pesan"
          value={note || ""}
          onChange={(e) => {
            setNote(e.target.value);
          }}
          onBlur={handleNoted}
          required
          placeholder="isi catatatn untuk alamat pengiriman ini"
          fullWidth
          size="small"
          variant="outlined"
        />
      </div>
      <Divider />
      <div className={classes.totalHarga}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography className={classes.liquidPrimary}>
            Resi Otomatis Marketplace
          </Typography>
          <InfoOutlinedIcon
            onClick={() => setDialodResi(true)}
            style={{ color: "grey", marginLeft: "5px", cursor: "pointer" }}
            fontSize="small"
          />{" "}
        </div>
        <div>
          <Typography color="primary" className={classes.liquidPrimary}>
            <Switch
              checked={checkedResi}
              onChange={handleOpenDialogResi}
              // edge="end"
              color="primary"
              // inputProps={{ "aria-labelledby": "switch-list-label-bluetooth" }}
              disabled={subcart?.checked === "N" || load}
            />
          </Typography>
        </div>
      </div>
      {findPromoOngkirAgain?.nama && !subcart?.resi_otomatis_mp ? (
        <Paper
          elevation={0}
          className={classes.wrapNotifFree}
          // onClick={() =>
          //   history.push("transaksi/transaksilist/sellerapp/tokorame")
          // }
        >
          <InfoOutlinedIcon fontSize="small" style={{ color: "#5AA5EA" }} />
          <Gap width={10} />
          <Typography style={{ fontSize: 12.3 }}>
            Dapatkan subsidi ongkir {textBadgePromoOngkir} dengan belanja min.{" "}
            {`${findPromoOngkirAgain?.min_transaksi / 1000}rb`}
            {findPromoOngkirAgain?.providers?.length > 0 ? (
              <>, (Khusus {findPromoOngkirAgain?.providers?.join(", ")})</>
            ) : null}
          </Typography>
        </Paper>
      ) : null}
      <Divider />
      <div className={classes.totalHarga}>
        <Typography className={classes.liquidPrimary}>
          Total Harga{" "}
          <span style={{ color: "gray" }}>{products?.length} produk</span>
        </Typography>
        <Typography color="primary" className={classes.liquidPrimary}>
          {currency(subcart?.total_tagihan)}
        </Typography>
      </div>
      <Divider style={{ height: "5px" }} />
      <Dialog
        open={dialogResiOtomatis}
        onClose={() => setDialogResiOtomatis(false)}
      >
        <DialogTitle>
          {" "}
          <Typography
            style={{
              fontSize: 18,
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            Pemberitahuan
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            style={{
              fontSize: 16,
            }}
          >
            Apakah anda sudah memiliki resi dari marketplace tempat anda
            berjualan? Jika sudah silahkan pilih ekspedisi dan isi resi
            otomatisnya
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            size="small"
            style={{ color: "black" }}
            onClick={() => setDialogResiOtomatis(false)}
          >
            No
          </Button>
          <Button
            variant="text"
            size="small"
            style={{ color: "black" }}
            onClick={onToggleSwitch}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Cart;
